// Where to find us: the Sprouts search opens Google Maps in a new tab; the state map and list are baked in by tools/build-pages.py.
import { $, reducedMotion, initChrome } from 'v2/ui.js';
import { RETAIL } from 'v2/catalog.js';
import { asset } from 'v2/asset.js';

initChrome();

/* ---------- Search: a native GET to Maps, so no popup blocker gets a say ---------- */
const form = $('[data-find-form]');
const input = $('[data-find-input]');
const query = $('[data-find-query]');
const error = $('[data-find-error]');

form.addEventListener('submit', (e) => {
  const where = input.value.trim();
  if (!where) {
    e.preventDefault();
    error.textContent = 'Enter a city, state, or ZIP to search nearby Sprouts locations.';
    input.setAttribute('aria-invalid', 'true');
    input.focus();
    return;
  }
  error.textContent = '';
  input.removeAttribute('aria-invalid');
  query.value = `${RETAIL.name} near ${where}`;
});
input.addEventListener('input', () => {
  if (!error.textContent) return;
  error.textContent = '';
  input.removeAttribute('aria-invalid');
});

/* ---------- Hero film: the stocked fridge, once the page has settled ---------- */
const video = $('[data-find-video]');
function startFilm() {
  video.src = asset('film/fridge-loop.mp4');
  video.preload = 'auto';
  video.play().catch(() => {});
}
if (!reducedMotion) {
  if (document.readyState === 'complete') setTimeout(startFilm, 200);
  else addEventListener('load', () => setTimeout(startFilm, 200), { once: true });
  if ('IntersectionObserver' in window) {
    new IntersectionObserver(([e]) => {
      if (!video.src) return;
      if (e.isIntersecting) video.play().catch(() => {}); else video.pause();
    }).observe(video);
  }
}
